<template>
    <v-container>
      <div class="mb-5">
        <material-card color="primary" title="Ubah Organisasi (PAU/Fakultas/Sekolah)" class="card-wrapper">
          <v-form>
            <v-row>
              <div class="form-input mt-5 mb-3">
                <p style="color: red">* Wajib Diisi</p>
              </div>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Kode Organisasi (PAU/Fakultas/Sekolah)<span style="color: red">*</span></p>
                  <v-text-field
                    dense 
                    placeholder="Kode"
                    required 
                    outlined 
                    v-model="formData.kode_org"
                    @input="$v.formData.kode_org.$touch()"
                    @blur="$v.formData.kode_org.$touch()"
                    :error-messages="kodeorgErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Nama Organisasi (PAU/Fakultas/Sekolah)<span style="color: red">*</span></p>
                  <v-text-field
                    dense
                    placeholder="Nama"
                    required 
                    outlined 
                    v-model="formData.nama"
                    @input="$v.formData.nama.$touch()"
                    @blur="$v.formData.nama.$touch()"
                    :error-messages="namaErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Parent</p>
                  <v-autocomplete
                    no-data-text="Tidak ada data"
                    dense
                    outlined
                    placeholder="Pilih Organisasi Parent" 
                    clearable
                    v-model="formData.id_parent"
                    :items="computedParents"
                    item-text="nama"
                    item-value="id"
                    @input="$v.formData.id_parent.$touch()"
                    @blur="$v.formData.id_parent.$touch()"
                  ></v-autocomplete>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Level</p>
                  <v-text-field
                    dense
                    required
                    outlined
                    v-model="computedLevel"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">File Stamp</p>
                  <v-file-input
                    dense
                    v-model="formData.file"
                    required
                    outlined
                    accept=".png"
                    @input="$v.formData.file.$touch()"
                    @blur="$v.formData.file.$touch()"
                    hint="File harus berformat PNG"
                    persistent-hint
                  >
                  </v-file-input>
                  <a v-if="this.formData.file_stamp !== '' " v-bind:href="filestampimg" v-bind:download="formData.file_stamp"> {{ this.formData.file_stamp }}</a> &nbsp;
                  <v-btn v-if="this.formData.file_stamp !== '' " small color="primary" dark @click="showFileStamp()">Lihat Gambar</v-btn>&nbsp;
                  <v-btn v-if="this.formData.file_stamp !== ''" small color="red" dark class="mr-4" @click="deleteDialog()">Hapus File Stamp</v-btn>&nbsp;
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Status</p>
                  <v-checkbox v-model="formData.status" v-if="formData.status === true" label="Aktif"/> 
                  <v-checkbox v-model="formData.status" v-else-if="formData.status === false" label="Tidak Aktif"/>
                </div>
              </v-col>
              <p style="color:red;">{{errorMessageNama}}</p>
              <v-col cols="12" class="text-right">
                <v-btn color="gray" dark @click="cancel()">Batal</v-btn>&nbsp;
                <v-btn color="primary" dark @click="updateData()">Simpan</v-btn>&nbsp;
              </v-col>
            </v-row>
          </v-form>
          <v-dialog v-model="dialog" max-height="800px" max-width="800px">
          <v-card class="card-modal" style="box-shadow:none!important;">
            <v-toolbar
              dark
              color="primary"
            >
              
              <v-toolbar-title>File Stamp Organisasi</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  icon
                  dark
                  @click="dialog = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <div class="text-center mt-6 mb-6">
              <img v-if="filestampimg && !filestampError" :src="filestampimg" alt="File Stamp Organisasi (PAU/Fakultas/Sekolah)" class="esign-stamp-preview" @error="filestampError = true">
              <p v-else class="esign-stamp-missing">
                <v-icon color="error">mdi-image-broken-variant</v-icon>
                Gambar file stamp tidak dapat dimuat. Pastikan file masih tersedia di server, lalu unggah ulang bila perlu.
              </p>
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogdel" max-width="500px">
          <v-card class="card-modal">
            <v-card-title>
              <span class="headline">Hapus File Stamp</span>
            </v-card-title>
  
            <v-card-text>
              Apakah anda yakin ingin menghapus File Stamp organisasi ini?
            </v-card-text>
  
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn @click="close">Batal</v-btn>
              <v-btn color="primary" dark @click="deleteFileStamp">Hapus</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
          <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Tutup</v-btn>
          </v-snackbar>
        </material-card>
      </div>

    </v-container>
  </template>
  
  <script>
 import { apiServer } from "../../setup-axios";
 import { backendUrl } from "../../config/env";
 import { minLength, maxLength, helpers, required } from "vuelidate/lib/validators";
  const textregex = helpers.regex('textregex', /^[a-zA-Z0-9 .,'()&\/-]{2,255}$/i)
  const koderegex = helpers.regex('koderegex', /^[a-zA-Z0-9]{2,255}$/i)
  export default {
    data: () => ({
      dialog: false,
      dialogdel: false,
      filestampimg: null,
      filestampError: false,
      successEdit: null,
      errorMessageNama: null,
      real_kode_org: null,
      real_file_stamp: null,
      organisasis: [],
      formData: {
        id: null,
        nama: null,
        kode_org: null,
        status: null,
        file_stamp: null,
        level: null,
        id_parent: null,
      },
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
    }),
    validations: {
      formData: {
        nama: {
          required,
          textregex,
          minLength: minLength(3),
          maxLength: maxLength(255)
        },
        kode_org: {
          required,
          koderegex,
          minLength: minLength(3),
          maxLength: maxLength(255)
        },
      },
      file: {
        required,
      },
    },
    mounted() {
      console.log("loading")
      this.getData();
      this.getListParent()
      this.fetchFileStamp();
    },
    computed: {
      computedLevel() {
        if (this.formData.id_parent) {
          const parent = this.organisasis.find(org => org.id === this.formData.id_parent);
          return parent ? parent.level + 1 : 0;
        }
        return 0;
      },
      computedParents() {
        return this.organisasis.filter(org => org.id !== this.formData.id);
      },
      namaErrors() {
        const errors = [];
        if (!this.$v.formData.nama.$dirty) return errors;
        !this.$v.formData.nama.required &&
        errors.push("Nama harus diisi");
        !this.$v.formData.nama.minLength &&
        errors.push("Nama minimal 3 karakter");
        !this.$v.formData.nama.maxLength &&
        errors.push("Nama maksimal 255 karakter");
        !this.$v.formData.nama.textregex &&
        errors.push("Nama hanya boleh mengandung huruf, angka, spasi, dan tanda . , ' ( ) & / -");
        
        return errors;
      },
      kodeorgErrors() {
        const errors = [];
        if (!this.$v.formData.kode_org.$dirty) return errors;
        !this.$v.formData.kode_org.required &&
        errors.push("Kode harus diisi");
        !this.$v.formData.kode_org.minLength &&
        errors.push("Kode minimal 3 karakter");
        !this.$v.formData.kode_org.maxLength &&
        errors.push("Kode maksimal 255 karakter");
        !this.$v.formData.kode_org.koderegex &&
        errors.push("Kode hanya boleh mengandung huruf dan angka");
        
        return errors;
      },
    },
    methods: {
      getData() {
        console.log("get data " + this.$route.params.kodeorg)
        apiServer
          .get("/organisasi/kode/" + this.$route.params.kodeorg)
          .then(response => {
            console.log(response.data.data)
            this.formData = response.data.data;
            this.real_kode_org = this.formData.kode_org;
            this.real_file_stamp = this.formData.file_stamp;
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
      },
      getListParent() {
        apiServer
        .get("/organisasi/all")
        .then(response => {
          this.organisasis = response.data.data;
          console.log(this.organisasis)
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
        });
      },
      updateData() {
        let createData = new FormData()
        createData.append("Id",this.formData.id)
        createData.append("Nama",this.formData.nama.trim(" "))
        createData.append("KodeOrg",this.formData.kode_org.trim(" "))
        createData.append("Status",this.formData.status)
        createData.append("file",this.formData.file)
        createData.append("Level",this.computedLevel)
        if(this.formData.id_parent === null || this.formData.id_parent === 0){
          createData.append("IdParent",JSON.stringify({"Int64": 0,"Valid": false}))
        }else{
          createData.append("IdParent",JSON.stringify({"Int64": this.formData.id_parent,"Valid": true}))
        }
        console.log(createData)
        apiServer
            .put("/organisasi/update",createData)
            .then(response => {
              console.log("Successfully updated organisasi:")
              console.log(response.data.data)
              localStorage.setItem('updateSuccess', "Organisasi " + this.formData.nama + " berhasil diubah.")
              this.$router.push("/organisasi")
            })
            .catch(error => {
              console.log("There was an error:", error.response); // Logs out the error
              this.errorMessageNama = error.response.data.message
            });
      },
      fetchFileStamp() {
        console.log("show image " +this.formData.file_stamp)
        var timestamp = new Date().getTime() // get current timestamp
        apiServer
          .get("/organisasi/filestamp/" + this.$route.params.kodeorg+ "?timestamp="  + timestamp,{ responseType: 'blob' })
          .then(response => {
            this.filestampError = false
            this.filestampimg = URL.createObjectURL(response.data)
          })
        // this.filestampimg = backendUrl + "/organisasi/filestamp/" + this.$route.params.kodeorg
        // this.dialog = true;
      },
      showFileStamp() {
        this.dialog = true;
      },
      deleteDialog(){
        console.log("delete filestamp")
        this.dialogdel = true
      },
      deleteFileStamp(){
        apiServer
          .delete("/organisasi/delete/filestamp/"+this.real_kode_org)
          .then(response => {
              this.showSnackbar("orange","File Stamp asli berhasil dihapus")
              this.getData()
              this.close()
            })
          .catch(error => {
              console.log("There was an error:", error); // Logs out the error
              this.getData()
              this.close()
            });
      },
      cancel() {
        this.$router.push('/organisasi')
      },
      close() {
        this.dialog = false;
        this.dialogdel = false;
      },
      showSnackbar(color, message) {
        console.log("snack " + color + " - " + message);
        this.snackbar = true;
        this.snackbarText = message;
        this.snackbarColor = color;
      },
      showMessage () {
        this.showSnackbar(
            this.$store.state.snackbar.snackbarColor,
            this.$store.state.snackbar.snackbarText
        )
        this.$store.dispatch('setSnackbar', {
          snackbarColor: null,
          snackbarText: null,
        })
    },
    }
  }
  </script>
  